<template>
  <div id="home">
    <div class="banner">
      <img src="../../assets/product/cp_banner.png" alt />
      <div class="divs">
        <p>强大的营销推广系统提升企业推广力 打造全民营销，创造私域流量池</p>
      </div>
    </div>
    <div class="content">
      <div class="content_one">
        <ul>
          <li id="1">
            <div class="content_one_con">
              <div class="one_left">
                <p>
                  <img src="../../assets/product/cp_icon_A01.png" alt />
                </p>
                <p>颠覆传统官网</p>
                <p>全面提升品牌曝光</p>
                <p>帮助企业标准化输出品牌，将品牌形象、新闻动态、招聘公告等信息统一展示，让每位员工都携带一个“移动官网”，一键转 发实现企业品牌</p>
              </div>
              <div class="one_right">
                <p>
                  <img src="../../assets/product/cp_icon_B01.png" alt />
                </p>
              </div>
            </div>
          </li>
          <li id="2">
            <div class="content_one_con">
              <div class="left-one">
                <p>
                  <img src="../../assets/product/cp_icon_B02.png" alt />
                </p>
              </div>
              <div class="one_left right-one">
                <p>
                  <img src="../../assets/product/cp_icon_A02.png" alt />
                </p>
                <p>智能物料降本增效</p>
                <p></p>
                <p>企业文库、品牌海报、获客文章、带货短视频、智能案例库全部 数字化，后台一键上传，前端全员使用。线上重复传递，减低成本，提升利用率</p>
              </div>
            </div>
          </li>
          <li id="3">
            <div class="content_one_con">
              <div class="one_left">
                <p>
                  <img src="../../assets/product/cp_icon_A03.png" alt />
                </p>
                <p>一键转发至微信</p>
                <p></p>
                <p>一键转发至微信群、朋友圈，支持嵌入公众号 面对面递名片，宣传物料印上小程序码</p>
              </div>
              <div class="one_right">
                <p>
                  <img src="../../assets/product/cp_icon_B03.png" alt />
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content_two">
        <div class="content_twos">
          <ul>
            <li id="4">
              <div class="content_one_con">
                <div class="left-one">
                  <p>
                    <img src="../../assets/product/cp_icon_B04.png" style="margin-top:16px" alt />
                  </p>
                </div>
                <div class="one_left right-one">
                  <p>
                    <img src="../../assets/product/cp_icon_A04.png" alt />
                  </p>
                  <p style="color:#fff;">一张名片开启电商</p>
                  <p style="color:#fff;width:450px">专属IP形象，快速引流</p>
                  <p
                    style="color:#C0D7FF;"
                  >快速搭建独立商城，让每个员工都拥有个人专属商城，进行在线销售；更有分销、拼团、优惠券等功能，让社交变成交。打造专属IP形象，让企业每个人都成为最好的“广告牌”，从而达到快速引流 </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="content_three">
        <ul>
          <li id="5">
            <div class="content_one_con">
              <div class="one_left">
                <p>
                  <img src="../../assets/product/cp_icon_A05.png" alt />
                </p>
                <p style="width:450px">24小时不间断追踪</p>
                <p>客户商机不遗漏</p>
                <p>用户浏览喜好清楚可见，数据分析快读锁定目标客户 不加微信自由对话，把握每一个商机，服务及时响应</p>
              </div>
              <div class="one_right">
                <p>
                  <img src="../../assets/product/cp_icon_B05.png" alt />
                </p>
              </div>
            </div>
          </li>
          <li id="6">
            <div class="content_one_con">
              <div class="left-one">
                <p>
                  <img src="../../assets/product/cp_icon_B06.png" alt />
                </p>
              </div>
              <div class="one_left right-one">
                <p>
                  <img src="../../assets/product/cp_icon_A06.png" alt />
                </p>
                <p>数据报表即时更新</p>
                <p></p>
                <p>企业运营数据即时更新，公司状况，了如指掌</p>
              </div>
            </div>
          </li>
          <li id="7">
            <div class="content_one_con">
              <div class="one_left">
                <p>
                  <img src="../../assets/product/cp_icon_A07.png" alt />
                </p>
                <p>智能管理提高人效</p>
                <p></p>
                <p>帮助企业实现员工和客户双向管理。管理者通过实时销售数据、推广数据、获客数据、评估绩效图智能管理员工，员工绩效 尽收眼底</p>
              </div>
              <div class="one_right">
                <p>
                  <img src="../../assets/product/cp_icon_B07.png" alt />
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content_four">
        <div class="content_four-con">
          <ul>
            <li id="8">
              <div class="content_one_con">
                <div class="left-one">
                  <p>
                    <img src="../../assets/product/cp_icon_B08.png" alt />
                  </p>
                </div>
                <div class="one_lefts">
                  <div class="one_left right-one">
                    <p>
                      <img src="../../assets/product/cp_icon_A08.png" alt />
                    </p>
                    <p>员工离职</p>
                    <p>一键交接</p>
                    <p style="width:264px">客户资源不流失，自动存储企业小程序 全面沉淀企业客户资产</p>
                  </div>
                  <div class="four_li">
                    <div class="four_li_1">
                      <p>
                        <img src="../../assets/product/cp_icon_sign.png" alt />
                      </p>
                      <p>线索</p>
                    </div>
                    <div class="four_li_1">
                      <p>
                        <img src="../../assets/product/cp_icon_sign.png" alt />
                      </p>
                      <p>客户</p>
                    </div>
                    <div class="four_li_1">
                      <p>
                        <img src="../../assets/product/cp_icon_sign.png" alt />
                      </p>
                      <p>雷达记录</p>
                    </div>
                    <div class="four_li_1">
                      <p>
                        <img src="../../assets/product/cp_icon_sign.png" alt />
                      </p>
                      <p>跟进记录</p>
                    </div>
                    <div class="four_li_1">
                      <p>
                        <img src="../../assets/product/cp_icon_sign.png" alt />
                      </p>
                      <p>动态</p>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="content_five" id="9">
        <div class="content_fives">
          <p class="content_five_p">轻松享受智能化AI拓客服务</p>
          <p class="content_five_p1">通过商城系统和CRM管理组件，将企业打造成推广与成交闭环的数字化平台</p>
          <img src="../../assets/product/cp_bg02.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    this.$emit("footer", true); //是否显示头部
    return {};
  },
  methods: {
    apply() {},
    home(){
      this.$router.push({
        path:'/'
      })
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#home {
  width: 100%;
  position: relative;
}

.top {
  width: 100%;
  background: #2b2f33;
  position: fixed;
  z-index: 99;
}

.top_one {
  width: 1200px;
  margin: 0 auto;
  /* overflow: hidden; */
}

.img {
  width: 200px;
  height: 40px;
  padding: 10px 57px 15px 0;
  float: left;
}

.top_li li {
  float: left;
  line-height: 65px;
  color: #fff;
  margin-right: 43px;
  cursor: pointer;
}

.top_li li:hover {
  color: #337eff;
}

.top_right {
  float: right;
  line-height: 65px;
}

.button {
  width: 90px;
  height: 33px;
  line-height: 0;
  padding: 0;
}

.bottons {
  background-color: transparent;
  color: #409eff;
  border: 1px solid #409eff;
}

.bottons:hover {
  background-color: #409eff;
}

.add {
  margin-left: 5px;
}

.banner {
  width: 100%;
  height: 400px;
  z-index: -1;
}

.banner img {
  width: 100%;
  height: 400px;
  position: relative;
}

.divs {
  width: 100%;
  height: 102px;
  position: absolute;
  top: 148px;
}

.divs p {
  width: 750px;
  height: 102px;
  text-align: center;
  font-size: 46px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 58px;
  margin: 0 auto;
}

.content {
  width: 100%;
}

.content_one {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.content_one ul li {
  width: 100%;
  height: 560px;
  overflow: hidden;
}

.one_left {
  width: 438px;
  float: left;
  margin: 121px 0 0 60px;
}

.one_left img {
  margin-bottom: 50px;
}

.one_left p:nth-child(2),
.one_left p:nth-child(3) {
  width: 305px;
  font-size: 38px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.one_left p:nth-child(4) {
  width: 438px;
  height: 68px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 39px;
  line-height: 26px;
}
.one_right {
  float: right;
}

.right-one {
  float: right;
  margin-right: 60px;
  margin-left: 0;
}

.one_lefts {
  width: 500px;
  float: right;
  margin-left: 0;
}

.left-one {
  float: left;
}

.content_one_con {
  width: 100%;
  height: 560px;
}

.content_two {
  width: 100%;
  height: 600px;
  background: linear-gradient(
    -55deg,
    rgba(51, 126, 255, 1),
    rgba(11, 92, 255, 1)
  );
}

.content_twos {
  width: 1200px;
  margin: 0 auto;
}

.content_three ul li {
  width: 100%;
  height: 560px;
  overflow: hidden;
}

.content_three {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.content_four {
  width: 100%;
  height: 600px;
  background: #f1f4f8;
}

.content_four-con {
  width: 1200px;
  margin: 0 auto;
}

.four_li img {
  float: left;
}

.four_li p {
  font-size: 14px;
  float: left;
  line-height: 15px;
  margin-right: 5px;
}

.four_li li {
  margin-right: 10px;
  float: left;
}

.four_li_1 {
  float: left;
  margin-right: 10px;
  color: #9fa19f;
  margin-top: 30px;
}

.content_five {
  width: 100%;
  height: 864px;
}

.content_fives {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.content_five_p {
  font-size: 34px;
  text-align: center;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 99px 0 29px 0;
}

.content_five_p1 {
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  color: rgba(159, 161, 159, 1);
  margin: 0 0 64px 0;
}

.floor {
  width: 100%;
  height: 553px;
  background: #0a1633;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 54px;
}

.floor_top {
  width: 100%;
  height: 207px;
  border-bottom: 1px solid #263758;
}

.floor_top p:nth-child(2) {
  text-align: center;
}

.shses {
  width: 140px;
  height: 44px;
}

.floor_left {
  width: 600px;
  color: #9ba5b4;
  font-size: 14px;
  float: left;
}

.floor_2 {
  width: 1200px;
  margin: 0 auto;
}

.floor_img {
  margin-bottom: 30px;
}

.floor_left_1 {
  line-height: 30px;
  margin-bottom: 30px;
}

.floor_left_2 p {
  float: left;
  line-height: 22px;
}

.floor_left_2 p img {
  margin: 0 5px;
}

.floor_right {
  width: 600px;
  float: right;
  color: #9ba5b4;
}

.floor_right_1 {
  float: left;
  margin-right: 80px;
}

.floor_right_1:nth-child(3) {
  margin-right: 0;
}

.floor_right_p {
  width: 189px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p1 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p2 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_ul1 {
  font-size: 12px;
  float: left;
  margin-right: 39px;
}

.floor_right_ul1 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul2 {
  font-size: 12px;
}

.floor_right_ul2 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul2 li:hover {
  color: #fff;
}

.floor_right_ul1 li:hover {
  color: #fff;
}

.floor_onep {
  text-align: center;
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 60px 0 40px 0;
}

.products,.productsa{
  position: relative;
}

.product {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.product_s {
  width: 558px;
  height: 192.3px;
  margin-left: -260px;
}

.products:hover .product {
  display: block;
}

.product-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.product-div {
  width: 558px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.product-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.product-div_p img {
  margin: 20px;
}

.product-div ul {
  width: 346px;
  height: 80px;
  float: left;
}

.product-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.producta {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.producta_s {
  width: 450px;
  height: 192.3px;
  margin-left: -190px;
}

.productsa:hover .producta {
  display: block;
}

.producta-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.producta-div {
  width: 450px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.producta-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.producta-div_p img {
  margin: 20px;
}

.producta-div ul {
  width: 238px;
  height: 80px;
  float: left;
  margin-top: 26px;
}

.producta-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/product/product.vue